import { QuestionTypes } from './enums'
import { QuestionData } from './types'

export default function isDropdownQuestion(value: QuestionData): value is QuestionData<number> {
  return value.type === QuestionTypes.DROPDOWN
}
